<template>
  <div class="app-container">
    <FaqPanel
      page="campaigns_block_lists"
      :top-offset="50"
      :max-width="350"
      :backdrop="true"
    />
    <el-container>
      <el-main class="wrapper">
        <div class="tab-container">
          <el-tabs v-model="activeTab">
            <el-tab-pane key="spots" label="Spots Lists" name="spots">
              <SpotsListsTab />
            </el-tab-pane>
            <!-- Hidden: Preset Spots Lists tab (feature abandoned) -->
            <el-tab-pane key="ips" label="IP Lists" name="ips" lazy>
              <IPsListsTab />
            </el-tab-pane>
            <el-tab-pane
              v-if="reTargetingAllowed"
              key="retargeting"
              label="Retargeting lists"
              name="retargeting"
              lazy
            >
              <RetargetingListsTab />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { ref, computed, defineComponent } from 'vue'
import IPsListsTab from './tabs/IPsListsTab.vue'
import SpotsListsTab from './tabs/SpotsListsTab.vue'
import RetargetingListsTab from './tabs/RetargetingListsTab.vue'
import FaqPanel from '@/components/FaqPanel/Index.vue'
import { useUserStore } from '@/store/modules/user'
import { FeatureFlags } from '@/apps/traforama/api/types'

export default defineComponent({
  name: 'BlockLists',
  components: {
    IPsListsTab,
    SpotsListsTab,
    RetargetingListsTab,
    FaqPanel
  },
  setup(props, context) {
    const activeTab = ref('spots')
    const userStore = useUserStore()

    const reTargetingAllowed = computed(() =>
      userStore.featureEnabled(FeatureFlags.Retargeting)
    )

    return {
      activeTab,
      reTargetingAllowed
    }
  }
})
</script>

<style lang="scss" scoped>
.el-main.wrapper {
  padding: 0 5px;
}

:deep(.filter-panel) {
  border-radius: 5px;

  :deep(.el-card__body) {
    padding: 0px 5px;
  }

  h3 {
    margin: 2px 8px 5px 8px;
    padding-top: 5px;
  }
}
</style>
